import React from "react";
import { IControlledMutator } from "sonobello.utilities.react";
import { ValidatedTextField } from "sonobello.utilities.react.mui";

import { ValidatedTextFieldProps } from "../../../../Components/Helpers/ValidatedTextField";

/** Adds onChangeValue and removes onChange and value. */
export interface IIntroFieldProps
  extends IControlledMutator<string | undefined>,
    Omit<ValidatedTextFieldProps, "onChange" | "value"> {
  /** onChangeValue is necessary since ValidatedTextField uses onAccepted and onChange. */
  onChangeValue: React.Dispatch<string | undefined>;
}

/** A reusable field for all inputs in Intro. */
const IntroField: React.FC<IIntroFieldProps> = ({ value, onChange, onChangeValue, ...rest }) => {
  return (
    <ValidatedTextField
      value={value}
      onChange={changedValue => onChangeValue(changedValue)}
      onAccepted={acceptedValue => onChange(acceptedValue)}
      {...rest}
    />
  );
};

export default IntroField;
